import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import InstallPWA from './components/InstallPWA';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Productos from './pages/Productos';
import Servicios from './pages/Servicios';
import Proveedores from './pages/Proveedores';
import CrearFactura from './pages/CrearFactura';
import Login from './pages/Login';
import FacturasList from "./pages/FacturasList";
import UsersPage from "./pages/admin/UsersPage";
import SubirFirma from "./pages/SubirFirma";
import Retenciones from "./pages/Retenciones";
import RetencionesContabilidad from "./pages/contabilidad/Retenciones";
import ComprasContabilidad from "./pages/contabilidad/ComprasSimplificado";
import ComprasManual from "./pages/contabilidad/ComprasManual";
import LibroDiario from "./pages/contabilidad/LibroDiario";
import CentroCostos from "./pages/contabilidad/CentroCostos";
import Reportes from "./pages/contabilidad/Reportes";
import ATS from "./pages/contabilidad/ATS";
import NotasCredito from "./pages/contabilidad/NotasCredito";
import LiquidacionCompras from "./pages/contabilidad/LiquidacionCompras";
import GuiaRemision from "./pages/contabilidad/GuiaRemision";
import ProductosInventario from "./pages/inventario/Productos";
import KardexProducto from "./pages/inventario/KardexProducto";
import IngresosEgresos from "./pages/inventario/IngresosEgresos";
import TransferenciasBodegas from "./pages/inventario/TransferenciasBodegas";
import GestionBodegas from "./pages/inventario/GestionBodegas";
import ImportarProductosCSV from "./pages/inventario/ImportarProductosCSV";
import PuntoDeVenta from "./pages/pos/PuntoDeVenta";
import ArqueoCaja from "./pages/pos/ArqueoCaja";
import ConfiguracionImpresora from "./pages/pos/ConfiguracionImpresora";
import RecibosVenta from "./pages/pos/RecibosVenta";
import UsuariosCajeros from "./pages/configuracion/UsuariosCajeros";
import InitSuperAdmin from "./pages/InitSuperAdmin";
import ConfiguracionEmpresa from "./pages/ConfiguracionEmpresa";
import CategoriasMarcas from "./pages/CategoriasMarcas";
import ConfiguracionEmail from "./pages/ConfiguracionEmail";
import ConfiguracionContable from "./pages/contabilidad/ConfiguracionContable";
import Cotizaciones from "./pages/Cotizaciones";

// Cuentas por Cobrar
import CuentasPorCobrar from "./pages/cuentas-cobrar/CuentasPorCobrar";
import EstadoCuenta from "./pages/cuentas-cobrar/EstadoCuenta";
import RegistrarCobro from "./pages/cuentas-cobrar/RegistrarCobro";
import Cobros from "./pages/cuentas-cobrar/Cobros";

// Cuentas por Pagar
import CuentasPorPagar from "./pages/cuentas-pagar/CuentasPorPagar";
import RegistrarPago from "./pages/cuentas-pagar/RegistrarPago";
import EstadoCuentaProveedor from "./pages/cuentas-pagar/EstadoCuentaProveedor";
import Pagos from "./pages/cuentas-pagar/Pagos";

// Tesorería
import Tesoreria from "./pages/tesoreria/Tesoreria";
import Cajas from "./pages/tesoreria/Cajas";
import Bancos from "./pages/tesoreria/Bancos";
import Transacciones from "./pages/tesoreria/Transacciones";
import FlujoCaja from "./pages/tesoreria/FlujoCaja";

// CRM
import Pipeline from "./pages/crm/Pipeline";
import Bandeja from "./pages/crm/Bandeja";
import Contactos from "./pages/crm/Contactos";

// Configuración CRM
import WhatsAppConfig from "./pages/configuracion/WhatsApp";
import ChatWidgetConfig from "./pages/configuracion/ChatWidget";
import AsistenteIA from "./pages/configuracion/AsistenteIA";

function App() {
  return (
    <AuthProvider>
      <Router>
        <InstallPWA />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/init-super-admin" element={<InitSuperAdmin />} />
          
          {/* POS - Pantalla completa sin Layout */}
          <Route path="/pos" element={
            <PrivateRoute roles={["ADMINISTRADOR", "CAJERO"]}>
              <PuntoDeVenta />
            </PrivateRoute>
          } />

          {/* Rutas protegidas con Layout */}
          <Route element={<PrivateRoute />}>
            <Route element={<Layout><Outlet /></Layout>}>
              {/* Todos los roles */}
              <Route path="/" element={<Dashboard />} />
              <Route path="/facturaslist" element={<FacturasList />} />

              {/* ADMINISTRADOR y CAJERO */}
              <Route path="/crear-factura" element={<CrearFactura />} />

              {/* ADMINISTRADOR y SUPER_ADMIN */}
              <Route path="/clientes" element={<Clientes />} />
              <Route path="/productos" element={<Productos />} />
              <Route path="/servicios" element={<Servicios />} />
              <Route path="/proveedores" element={<Proveedores />} />
              <Route path="/retenciones" element={<Retenciones />} />
              <Route path="/cotizaciones" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <Cotizaciones />
                </PrivateRoute>
              } />

              {/* ADMINISTRADOR */}
              <Route path="/subir-firma" element={<SubirFirma />} />
              <Route path="/configuracion" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <ConfiguracionEmpresa />
                </PrivateRoute>
              } />
              <Route path="/configuracion/categorias-marcas" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <CategoriasMarcas />
                </PrivateRoute>
              } />
              <Route path="/configuracion/email" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <ConfiguracionEmail />
                </PrivateRoute>
              } />

              {/* Contabilidad - Solo ADMINISTRADOR */}
              <Route path="/compras" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <ComprasContabilidad />
                </PrivateRoute>
              } />
              <Route path="/compras-manual" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <ComprasManual />
                </PrivateRoute>
              } />
              <Route path="/contabilidad/retenciones" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <RetencionesContabilidad />
                </PrivateRoute>
              } />
              <Route path="/contabilidad/libro-diario" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <LibroDiario />
                </PrivateRoute>
              } />
              <Route path="/contabilidad/centro-costos" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <CentroCostos />
                </PrivateRoute>
              } />
              <Route path="/contabilidad/reportes" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <Reportes />
                </PrivateRoute>
              } />
              <Route path="/contabilidad/ats" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <ATS />
                </PrivateRoute>
              } />
              <Route path="/contabilidad/configuracion" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <ConfiguracionContable />
                </PrivateRoute>
              } />

              <Route path="/contabilidad/notas-credito" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <NotasCredito />
                </PrivateRoute>
              } />
              <Route path="/contabilidad/liquidacion-compras" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <LiquidacionCompras />
                </PrivateRoute>
              } />
              <Route path="/contabilidad/guia-remision" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <GuiaRemision />
                </PrivateRoute>
              } />
              
              {/* Inventario - ADMINISTRADOR y CAJERO */}
              <Route path="/inventario/productos" element={
                <PrivateRoute roles={["ADMINISTRADOR", "CAJERO"]}>
                  <ProductosInventario />
                </PrivateRoute>
              } />
              <Route path="/inventario/kardex" element={
                <PrivateRoute roles={["ADMINISTRADOR", "CAJERO"]}>
                  <KardexProducto />
                </PrivateRoute>
              } />
              <Route path="/inventario/ingresos-egresos" element={
                <PrivateRoute roles={["ADMINISTRADOR", "CAJERO"]}>
                  <IngresosEgresos />
                </PrivateRoute>
              } />
              <Route path="/inventario/transferencias" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <TransferenciasBodegas />
                </PrivateRoute>
              } />
              <Route path="/inventario/bodegas" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <GestionBodegas />
                </PrivateRoute>
              } />
              <Route path="/inventario/importar-csv" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <ImportarProductosCSV />
                </PrivateRoute>
              } />
              <Route path="/pos/arqueo-caja" element={
                <PrivateRoute roles={["ADMINISTRADOR", "CAJERO"]}>
                  <ArqueoCaja />
                </PrivateRoute>
              } />
              <Route path="/pos/impresora" element={
                <PrivateRoute roles={["ADMINISTRADOR", "CAJERO"]}>
                  <ConfiguracionImpresora />
                </PrivateRoute>
              } />
              <Route path="/pos/recibos" element={
                <PrivateRoute roles={["ADMINISTRADOR", "CAJERO"]}>
                  <RecibosVenta />
                </PrivateRoute>
              } />
              <Route path="/configuracion/usuarios" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <UsuariosCajeros />
                </PrivateRoute>
              } />

              {/* Cuentas por Cobrar - ADMINISTRADOR */}
              <Route path="/cuentas-cobrar" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <CuentasPorCobrar />
                </PrivateRoute>
              } />
              <Route path="/cuentas-cobrar/estado-cuenta" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <EstadoCuenta />
                </PrivateRoute>
              } />
              <Route path="/cuentas-cobrar/estado-cuenta/:clienteId" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <EstadoCuenta />
                </PrivateRoute>
              } />
              <Route path="/cuentas-cobrar/registrar-cobro" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <RegistrarCobro />
                </PrivateRoute>
              } />
              <Route path="/cuentas-cobrar/cobros" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <Cobros />
                </PrivateRoute>
              } />

              {/* Cuentas por Pagar - ADMINISTRADOR */}
              <Route path="/cuentas-pagar" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <CuentasPorPagar />
                </PrivateRoute>
              } />
              <Route path="/cuentas-pagar/registrar-pago" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <RegistrarPago />
                </PrivateRoute>
              } />
              <Route path="/cuentas-pagar/estado-cuenta/:proveedorId" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <EstadoCuentaProveedor />
                </PrivateRoute>
              } />
              <Route path="/cuentas-pagar/pagos" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <Pagos />
                </PrivateRoute>
              } />

              {/* Tesorería - ADMINISTRADOR */}
              <Route path="/tesoreria" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <Tesoreria />
                </PrivateRoute>
              } />
              <Route path="/tesoreria/cajas" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <Cajas />
                </PrivateRoute>
              } />
              <Route path="/tesoreria/bancos" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <Bancos />
                </PrivateRoute>
              } />
              <Route path="/tesoreria/transacciones" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <Transacciones />
                </PrivateRoute>
              } />
              <Route path="/tesoreria/flujo-caja" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <FlujoCaja />
                </PrivateRoute>
              } />

              {/* Solo SUPER_ADMIN */}
              <Route path="/admin/empresas" element={
                <PrivateRoute roles={["SUPER_ADMIN"]}>
                  <UsersPage />
                </PrivateRoute>
              } />

              {/* CRM - ADMINISTRADOR */}
              <Route path="/crm/pipeline" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <Pipeline />
                </PrivateRoute>
              } />
              <Route path="/crm/bandeja" element={
                <PrivateRoute roles={["ADMINISTRADOR", "CAJERO"]}>
                  <Bandeja />
                </PrivateRoute>
              } />
              <Route path="/crm/contactos" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <Contactos />
                </PrivateRoute>
              } />

              {/* Configuración CRM - ADMINISTRADOR */}
              <Route path="/configuracion/whatsapp" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <WhatsAppConfig />
                </PrivateRoute>
              } />
              <Route path="/configuracion/chat-widget" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <ChatWidgetConfig />
                </PrivateRoute>
              } />
              <Route path="/configuracion/asistente-ia" element={
                <PrivateRoute roles={["ADMINISTRADOR"]}>
                  <AsistenteIA />
                </PrivateRoute>
              } />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
